import utils from './utils';

const APP_AUDIO_SELECTOR = '#app-audio'

let appAudioEl = null
let appAudioFailedSrc = null
const audioPlay = function(newSrc) {
  if (!appAudioEl || !newSrc || appAudioEl.muted) {
    return false
  }

  const currentSrc = appAudioEl.getAttribute('src')
  if (currentSrc !== newSrc) {
    appAudioEl.pause()
    appAudioEl.setAttribute('src', newSrc)
    appAudioEl.load()
  }

  // https://developers.google.com/web/updates/2016/03/play-returns-promise
  // https://developers.google.com/web/updates/2017/09/autoplay-policy-changes
  if (appAudioEl.paused) {
    const promise = appAudioEl.play()
    if (promise !== undefined) {
      promise.then(_ => {
        // Autoplay started!
        appAudioFailedSrc = null
      }).catch(error => {
        // Autoplay was prevented.
        // Show a "Play" button so that user can start playback.
        appAudioFailedSrc = newSrc
      });
    }
  } else {
    //appAudioEl.pause()
  }
}
const audioPause = function() {
  if (!appAudioEl) {
    return false
  }
  if (!appAudioEl.paused) {
    appAudioEl.pause()
  }
}

const appInit = function() {
  window.app.$body.append('<audio id="app-audio" src="" muted></audio>')
  // https://www.w3schools.com/tags/ref_av_dom.asp
  appAudioEl = document.querySelector(APP_AUDIO_SELECTOR)

  //appAudioEl.muted = false

  window.app.$html.addClass('audio-muted')

  $(document).on('click', '[data-audio-toggle]', function(e){
    appAudioEl.muted = !appAudioEl.muted
    window.app.$html.toggleClass('audio-muted')

    if (!appAudioEl.muted) {
      if (appAudioFailedSrc) {
        audioPlay(appAudioFailedSrc)
      }
    }
  })

  $(document).on('click', '[data-audio--click]', function(e){
    audioPlay(this.getAttribute('data-audio'))
  })
  $(document).on('mouseenter', '[data-audio--mouseenter]', function(e){
    audioPlay(this.getAttribute('data-audio'))
  })
}

const appDestroy = function() {
  $(document).off('click', '[data-audio--click]')
  $(document).off('mouseenter', '[data-audio--mouseenter]')
}

const init = function() {
  // empty previuous failed audio src
  appAudioFailedSrc = null

  //if (!window.app.isTouch()) {
  const $autoAudio = $('[data-audio--auto]').first()
  if ($autoAudio.length) {
    const newSrc = $autoAudio.attr('data-audio')
    if (appAudioEl.muted) {
      appAudioFailedSrc = newSrc
    } else {
      audioPlay(newSrc)
    }
  }
}

const destroy = function() {
  audioPause()
}

export default {appInit, appDestroy, init, destroy}
